import { NgModule } from '@angular/core';
import { TableComponent } from './table/table.component';
import { FormComponent } from './form/form.component';
import { CommonModule } from '@angular/common';
import { TabFormComponent } from './tab-form/tab-form.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { DataCommunicationService } from '../clientSerivces/data-communication.service';
import { NotificationService } from '../clientSerivces/notification.service';
import { DateUtilityService } from '../services/date-utility.service';
import { RouterModule } from '@angular/router';
// DocumentViewerDialogComponent is now imported from SharedComponents library below
import { DetailTabsComponent } from './detail-tabs/detail-tabs.component';

// ? Shared library (common between admin client and employee portal) ??????????
import { 
    SharedComponentsModule,
    TimesheetCalendarModule,  // ? reusable timesheet calendar + time-view cells
    ChartCanvasComponent, 
    DashboardViewComponent,
    SortModalComponent,
    DocumentViewerDialogComponent,
    NgIdleService  // ? Import NgIdleService from shared library instead
} from 'shared-components';

// Angular Material Modules
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';

// Custom Date Adapter
import { AppDateAdapter } from '../adapters/app-date-adapter';
import { MATERIAL_DATE_FORMATS, APP_LOCALE } from '../constants/date-formats';

@NgModule({
    declarations: [
        TableComponent,
        FormComponent,
        TabFormComponent,
        // DocumentViewerDialogComponent now imported from SharedComponents library
        DetailTabsComponent
        // TimesheetCalendarComponent and TimeViewComponent now imported from SharedComponents library
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgxPaginationModule,
        FormsModule,
        RouterModule,
        SharedComponentsModule,       // ? shared library
        TimesheetCalendarModule,      // ? reusable timesheet calendar + time-view cells
        // Material Modules
        MatSelectModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        MatOptionModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatTooltipModule,
        NgxMatSelectSearchModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatCardModule,
        MatChipsModule
     ] ,
    providers: [ 
        DataCommunicationService,
        NgIdleService,
        NotificationService,
        DateUtilityService,
        // AdvancedSortService removed - provided by components that use it
        // Configure custom date adapter for consistent MM/DD/YYYY formatting
        { provide: DateAdapter, useClass: AppDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: MATERIAL_DATE_FORMATS },
        { provide: MAT_DATE_LOCALE, useValue: APP_LOCALE }
    ],
    exports: [
        TableComponent,
        FormComponent,
        TabFormComponent,
        DocumentViewerDialogComponent, // Add the missing component export
        DetailTabsComponent,
        // TimesheetCalendarComponent and TimeViewComponent now re-exported via TimesheetCalendarModule
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        RouterModule,
        TimesheetCalendarModule,      // ? re-export so feature modules get calendar components
        // Re-export individual shared library pieces � TableComponent is intentionally
        // excluded to avoid NG0300 clash with the local TableComponent declared above.
        ChartCanvasComponent,
        DashboardViewComponent,
        SortModalComponent,  // Export SortModalComponent from SharedComponents library
        // Export Material Modules
        MatSelectModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        MatOptionModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatTooltipModule,
        NgxMatSelectSearchModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatCardModule,
        MatChipsModule
    ]
})
export class SharedModule { }